// src/Components/layout/Sidebar.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/landing/icons/logo.svg"

// Simple line icons to match the design
const IconDashboard = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="9" rx="2" />
    <rect x="14" y="3" width="7" height="5" rx="2" />
    <rect x="14" y="11" width="7" height="10" rx="2" />
    <rect x="3" y="15" width="7" height="6" rx="2" />
  </svg>
);

const IconTasks = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M9 11l3 3L21 5" />
  </svg>
);

const IconBranches = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const IconTrack = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const IconSettings = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 8 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 3.6 15a1.65 1.65 0 0 0-1.51-1H2a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 3.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 8 3.6 1.65 1.65 0 0 0 9 2.09V2a2 2 0 0 1 4 0v.09A1.65 1.65 0 0 0 16 3.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 20.4 9c.36.53.56 1.16.6 1.8V11a1.65 1.65 0 0 0-1 1.51z" />
  </svg>
);

const IconHelp = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-2 2.5-2 4" />
    <line x1="12" y1="17" x2="12" y2="17" />
  </svg>
);

const IconClose = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export default function Sidebar({ isOpen, onClose }) {
  return (
    <aside className={`mq-sidebar ${isOpen ? 'mq-sidebar-open' : ''}`}>
      {/* Mobile close button */}
      <button className="mq-sidebar-close" onClick={onClose} aria-label="Close menu">
        <IconClose />
      </button>
      {/* Yellow header with circular logo */}
      <div className="mq-sidebar-header">
        <div className="mq-sidebar-logo-wrap">
          <img src={logo} alt="Marquee Couriers" className="mq-sidebar-logo" />
        </div>
      </div>

      <div className="mq-sidebar-inner">
        {/* MAIN section */}
        <div className="mq-nav-section">
          <div className="mq-nav-label">MAIN</div>
          <nav className="mq-nav">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconDashboard />
              </span>
              <span>Dashboard</span>
            </NavLink>

            <NavLink
              to="/tasks"
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconTasks />
              </span>
              <span>Tasks</span>
            </NavLink>

            <NavLink
              to="/branches"
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconBranches />
              </span>
              <span>Branches</span>
            </NavLink>

            <NavLink
              to="/track-order"
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconTrack />
              </span>
              <span>Track Order</span>
            </NavLink>
          </nav>
        </div>

        {/* OTHER section */}
        <div className="mq-nav-section mq-nav-section-bottom">
          <div className="mq-nav-label">OTHER</div>
          <nav className="mq-nav">
            <NavLink
              to="/settings"
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconSettings />
              </span>
              <span>Settings</span>
            </NavLink>
            <NavLink
              to="/help-support"
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconHelp />
              </span>
              <span>Help &amp; Support</span>
            </NavLink>
          </nav>
        </div>
      </div>
    </aside>
  );
}
